import { useDispatch, useSelector } from "react-redux";
import ButtonBig from "../../../shared/components/button_big";
import { RoutesWeb } from "../../../shared/interfaces/routes";
import { mainSlice, selectMainState } from "../../../stateManagement/redux";
import { DepartmentNameEnum } from "../../../stateManagement/redux/slices/shared/interfaces";

export const GerenciaTecnicaOptions = (props: { onClick: any }) => {
    const mainState = useSelector(selectMainState);

    const dispatch: any = useDispatch();

    const onClick = () => {
        dispatch(mainSlice.actions.setShowMenu());
    };

    const onClickMenu = (path: string) => {
        if (
            !mainState.activeDepartment ||
            mainState?.activeDepartment?.id !== DepartmentNameEnum.wellWhisper
        ) {
            localStorage.setItem(
                "activeDepartmentId",
                DepartmentNameEnum.wellWhisper
            );
            dispatch(mainSlice.actions.setShowMenu());
        }
        props.onClick(path);
    };

    return (
        <div className="wrap-main__menu">
            <div className="wrap-main__menu__container_header">
                <img
                    src="/assets/icons/well_whisper_blue.svg"
                    alt="Well Whisper"
                    height={80}
                    width={80}
                    style={{ padding: 0 }}
                />
                <div className="wrap-main__menu__title">WELL WHISPER</div>
                <div
                    className="wrap-main__menu__close_icon"
                    onClick={() => onClick()}
                >
                    <img
                        src="/assets/icons/arrow-left.svg"
                        alt="Well Whisper"
                        height={8}
                        width={8}
                    />
                </div>
            </div>
            <div className="wrap-main__menu__container_buttons">
                <ButtonBig
                    text="DASHBOARD"
                    onClick={() => onClickMenu("/gto/dashboard/0")}
                />
                {/* <ButtonBig text='Ali' onClick={() => onClickMenu('/well-whisper/ali')} /> */}
                <ButtonBig
                    text="HISTORIAL DE ACTIVIDADES"
                    onClick={() =>
                        onClickMenu(
                            RoutesWeb.gerencia_tecnica_operaciones.history
                        )
                    }
                />
                <ButtonBig
                    text="SUBIDAS DE ARCHIVOS"
                    onClick={() =>
                        onClickMenu(
                            RoutesWeb.gerencia_tecnica_operaciones.upload
                        )
                    }
                />
            </div>
        </div>
    );
};
